import { useSnackbar } from 'notistack';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { useLoggedInUserRoles } from '~/components/Auth';
import { useSelectedEmployeeContext } from '~/components/SelectedEmployee';
import { useAuthentication } from '~/data/user/useAuthentication';
import {
  DispatchReduxFetch,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { useInterval } from '~/hooks/useInterval';
import { Providers } from '~/Providers';
import { WorklistTable } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable';

import { LibraryComponentProviders } from '../components/LibraryComponentProviders';

export type PeopleCollaborationTabContentProps = {
  employeeId?: number;
};

export const PeopleCollaborationTabContent = (
  props: PeopleCollaborationTabContentProps,
) => {
  const { employeeId } = props;

  const { userDetails, isAuthenticated } = useAuthentication();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const loggedInUserRoles = useLoggedInUserRoles();

  const { selectedEmployeeId, refreshSelectedEmployeeId } =
    useSelectedEmployeeContext();

  useInterval(
    !!employeeId && employeeId !== selectedEmployeeId,
    () => {
      refreshSelectedEmployeeId();
    },
    1000,
  );

  const {
    requiredStatus: { isReady },
  } = useInitializeCommonReduxData({
    required: [
      DispatchReduxFetch.AllEmployees,
      DispatchReduxFetch.AllOrgUnits,
      DispatchReduxFetch.ApplicationConfig,
      DispatchReduxFetch.CompanyData,
      DispatchReduxFetch.AllEnums,
    ],
  });

  if (
    !isReady ||
    !isAuthenticated ||
    !userDetails ||
    !t ||
    !enqueueSnackbar ||
    !loggedInUserRoles
  ) {
    return null;
  }

  return (
    <LibraryComponentProviders>
      <WorklistTable />
    </LibraryComponentProviders>
  );
};

export const renderPeopleCollaborationTabContent = (
  containerId: string,
  props: PeopleCollaborationTabContentProps,
) => {
  ReactDOM.render(
    <Providers>
      <PeopleCollaborationTabContent {...props} />
    </Providers>,
    document.getElementById(containerId),
  );
};
